import { IFilter } from '../../types/filters';
import { SaleTypeContainer } from '../../containers/advancedFilters/SaleTypeContainer';

export const saleType: IFilter = {
  component: SaleTypeContainer,
};
